module.exports = __webpack_public_path__ + "static/img/20.bd9a0e74.jpg";